
export const isAbsoluteUrl = (url) => url.includes('://');

export const getCurrentUrlInfo = () => {
  const url = new URL(window.location.href);

  const protocol = url.protocol.replace(/:/g, '');
  const hostname = url.hostname;
  const port = url.port ? `:${url.port}` : '';
  const query = window.location.search;
  const queryParameters = new Proxy(new URLSearchParams(query), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  return {
    protocol,
    hostname,
    port,
    site: `${protocol}://${hostname}`,
    path: window.location.pathname,
    query,
    queryParameters,
  };
};

export const completeOrRebuildUrl = (url) => {
  const currentUrlInfo = getCurrentUrlInfo();

  const find = url.match(/^:([0-9]{2,4})/g);
  const port = find ? find[0] : currentUrlInfo.port;
  const path = url.split(find).filter((i) => !!i)[0];

  return `${currentUrlInfo.site}${port}${path}`;
}

export const getUrlParamValue = (paramToSearch) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has(paramToSearch))
    return urlParams.get(paramToSearch);
  
  return null;
}

export const isNasiConfigured = () => {
  if (new URLSearchParams(window.location.search).has('Nasi')) return true;

  try {
    return sessionStorage.getItem('Nasi') !== null;
  } catch (error) {
    return false;
  }
};

export default {
    isAbsoluteUrl,
    getCurrentUrlInfo,
    completeOrRebuildUrl
}
